import { Box, TextPreset } from '@facile-it/full-metal-ui/components'
import * as React from 'react'
import { routes } from '../routes'
import * as styles from '../styles/Pages.css'
import { AppLink } from './routing/AppLink'

export const Documents: React.FC<{ hideComplaints?: boolean }> = ({ hideComplaints = false }) => (
    <Box
        paddingY={{ mobile: 'l', desktop: '3xl' }}
        paddingX={{ mobile: 'l', desktop: '3xl' }}
        className={styles.shadowWrapper}
        textAlign="center"
    >
        <TextPreset
            preset="title-m"
            component="p"
            fontWeight="bold"
            fontColor="success400"
            paddingBottom={{ mobile: 'm', tablet: 'xxs' }}
        >
            Tieni a portata di mano il codice della polizza o del preventivo
        </TextPreset>
        <TextPreset
            className={styles.specialLineHeight}
            preset="paragraph-xl"
            fontWeight="medium"
            paddingBottom={hideComplaints ? 'none' : 'l'}
        >
            Per velocizzare la richiesta, scrivici o comunicaci il codice della tua polizza o del tuo preventivo (ad
            esempio, SAT12345678 per la tua polizza o PRV12345678 per il tuo preventivo): puoi trovarlo sulle email che
            ti abbiamo inviato, sul tuo contratto o all&apos;interno dell&apos;Area Riservata.
        </TextPreset>
        <Box display={hideComplaints ? 'none' : 'block'}>
            <TextPreset
                preset="title-xxs"
                component="p"
                fontWeight="bold"
                fontColor="success400"
                textTransform="uppercase"
                paddingBottom={{ mobile: 'm', tablet: 'xxs' }}
            >
                Invia reclami o segnalazioni
            </TextPreset>
            <TextPreset preset="paragraph-xl" fontWeight="medium" className={styles.specialLineHeight}>
                Per sapere come segnalarci un problema, visita la sezioni{' '}
                <strong>
                    <u>
                        <AppLink href={routes.reclami}>Reclami</AppLink>
                    </u>
                </strong>
            </TextPreset>
        </Box>
    </Box>
)
